/**
 * Application-level entity type labels for IntegrationLog polymorphic refs.
 * Stored as plain strings in MongoDB so new types never require schema migrations.
 * Values align with Prisma model names (e.g. "Order", "Event").
 */
export const IntegrationLogEntityType = {
  ORDER: "Order",
  EVENT: "Event",
  PAYMENT: "Payment",
  TICKET: "Ticket",
  USER: "User",
  RESERVATION: "Reservation",
  DTCM_CUSTOMER: "DTCMCustomer",
} as const;

export type IntegrationLogEntityTypeName =
  (typeof IntegrationLogEntityType)[keyof typeof IntegrationLogEntityType];

export type IntegrationLogEntityRef = {
  entityType: IntegrationLogEntityTypeName | (string & {});
  entityId: string;
};

export function integrationLogEntity(
  entityType: IntegrationLogEntityTypeName | string,
  entityId: string
): IntegrationLogEntityRef {
  return { entityType, entityId };
}

export function orderIntegrationEntity(orderId: string): IntegrationLogEntityRef {
  return integrationLogEntity(IntegrationLogEntityType.ORDER, orderId);
}

export function eventIntegrationEntity(eventId: string): IntegrationLogEntityRef {
  return integrationLogEntity(IntegrationLogEntityType.EVENT, eventId);
}
